import { render, staticRenderFns } from "./copy-features-dialog.vue?vue&type=template&id=2a7e9fed"
import script from "./copy-features-dialog.vue?vue&type=script&lang=js"
export * from "./copy-features-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports